
<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      </el-breadcrumb>


      <!-- 搜索筛选 -->
      <el-form :inline="true" class="user-search">
        <el-form-item label="">
  
          <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        </el-form-item>
      </el-form>





  
      <!--列表-->
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%; margin-top: 20px;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
  
        <el-table-column sortable prop="title" label="标题" width="200">
        </el-table-column>
        <el-table-column sortable prop="address" label="举办方" width="200">
        </el-table-column>
  
  
        <el-table-column prop="name" label="活动海报" width="150">
          <template slot-scope="scope">
            <img class="tech-img" style="width: 120px; height: 68px;" :src="scope.row.coverPlan">
          </template>
        </el-table-column>
  
  
  
        <el-table-column sortable prop="createTime" label="创建时间" width="150">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
  
        <el-table-column align="center" label="操作" min-width="300">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteArticle(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 编辑界面 -->
      <el-dialog :title="title" :visible.sync="editFormVisible" width="80%" @click="closeDialog">
        <el-form label-width="120px" ref="editForm">
          <el-form-item label="标题" prop="deptName">
            <el-input size="small" v-model="formData.title" auto-complete="off" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="举办方" prop="deptName">
            <el-input size="small" v-model="formData.address" auto-complete="off" placeholder="请输入"></el-input>
          </el-form-item>

          
  
          <el-form-item label="封面图" style="">
  
            <div class="upload-demo">
              <el-upload action="" :http-request="mainImgUpload1" :show-file-list="false" list-type="picture-card">
                <i class="el-icon-plus"></i>
              </el-upload>
              <img v-if="formData.coverPlan" :src="formData.coverPlan" class="avatar">
  
            </div>
            <el-progress v-if="uploadProgress.show" :percentage="uploadProgress.percent" style="margin-top: 10px; width: 148px;"></el-progress>
  
          </el-form-item>


          <el-form-item label="内容" prop="deptName">

            <quill-editor
                v-model="formData.richText"
                :options="editorOption"
                style="height: 200px;"
                ref="QuillEditor">
            </quill-editor>

            </el-form-item>



            <el-form-item  prop="deptName"></el-form-item>
            <el-form-item  prop="deptName"></el-form-item>
            <el-form-item  prop="deptName"></el-form-item>
            <el-form-item  prop="deptName"></el-form-item>
  
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="addArticle()"
            v-if="title == '添加'">添加</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="upArticle()"
            v-if="title == '修改'">修改</el-button>
        </div>
      </el-dialog>
  
  
  
  
      <!--    自定义上传组件-->
      <el-dialog
        title="选择图片"
        :visible.sync="uploadVisible"
        width="30%">
        <div>
          
  
             <div class="upload-demo">
                    <el-upload
                    action=""
                    :http-request="mainImgUpload"
                    :show-file-list="false"
                    list-type="picture-card" >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <!-- <img v-if="formData.mainImg" :src="formData.mainImg" class="avatar"> -->
       
              </div>
  
  
  
        </div>
  
      </el-dialog>
  
    </div>
  </template>
  
  <script>
  import {

    
    addArticle,
    upArticle,
    deleteArticle,
    getArticleList,


  
  } from "../../api/userMG";
  import Pagination from "../../components/Pagination";
  import client from "@/utils/ossClient.js";
  import VueQuillEditor from "vue-quill-editor";
  import "quill/dist/quill.core.css";
  import "quill/dist/quill.snow.css";
  
  // 工具栏配置
  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],
  
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction
  
    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
  
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ["link", "image", "video"], // 对于图片上传这是重点
    ["clean"], // remove formatting button
  ];
  
  export default {
    data() {
      return {
        cursorIndex: 0,
        editorOption: {
          modules: {
            toolbar: {
              container: toolbarOptions, // 工具栏
              handlers: {
                image: (value) => {
                  if (value) {
                    // 在这里编写图片按钮点击操作
                    this.uploadVisible = true;
                    this.cursorIndex =
                      this.$refs.QuillEditor.quill.getSelection().index;
                  } else {
                    this.quill.format("image", false);
                  }
                },
              },
            },
          },
        },
        uploadVisible: false,
  
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: "添加",
  
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10,
        },
  
  
        classifyList: [],
        classifyId: "",
  
        classifyTwoList: [],
        classifyTwoId: "",
  
        formData: {
          type: 0,
          title: "",
          address: "",
          coverPlan: "",
          richText:""


        },
        uploadProgress: { show: false, percent: 0 },
      };
    },
    // 注册组件
    components: {
      Pagination,
      VueQuillEditor,
    },
    /**
     * 数据发生改变
     */
  
    /**
     * 创建完毕
     */
    created() {
      // this.getdata(this.formInline)
  
      this.getArticleList();
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
          //自定义上传方法..
      mainImgUpload1(file) {
  
        //判断扩展名
        const tmpcnt = file.file.name.lastIndexOf(".");
        const exname = file.file.name.substring(tmpcnt + 1);
        const fileName = file.file.uid + "." + exname;
  
        this.uploadProgress.show = true;
        this.uploadProgress.percent = 0;

        client
          .put(fileName, file.file, {
            progress: (p) => {
              this.uploadProgress.percent = Math.round(p * 100);
            }
          })
          .then((res) => {
            console.log("res",res)
            if (res.url) {
              this.formData.coverPlan = res.url;
              setTimeout(() => { this.uploadProgress.show = false; }, 1000);
            } else {
              this.$message.error("文件上传失败");
              this.uploadProgress.show = false;
            }
          })
          .catch((err) => {
            this.uploadProgress.show = false;
          });
      },
      //自定义上传方法..
      mainImgUpload(file) {
        var self = this;
        //判断扩展名
        const tmpcnt = file.file.name.lastIndexOf(".");
        const exname = file.file.name.substring(tmpcnt + 1);
        const names = ["jpg", "jpeg", "webp", "png", "bmp"];
        // if (names.indexOf(exname) < 0) {
        //   this.$message.error("不支持的格式!");
        //   return;
        // }
        const fileName = file.file.uid + "." + exname;
        client
          .put(fileName, file.file)
          .then((res) => {
            if (res.url) {
              console.log("2222222", res);
              self.getUrl(res.url);
            } else {
              this.$message.error("文件上传失败");
            }
          })
          .catch((err) => {});
      },
      getUrl(url) {
        this.uploadVisible = false;
        // 获取富文本组件实例
        let quill = this.$refs.QuillEditor.quill;
        // 如果上传成功
        if (url) {
          // 插入图片，res为服务器返回的图片链接地址
  
          quill.insertEmbed(this.cursorIndex, "image", url);
          // 调整光标到最后
          quill.setSelection(this.cursorIndex + 1);
        } else {
          // 提示上传失败信息
        }
      },
          //修改
    addArticle() {
        this.loading = true;
        var formData = this.formData;
        
        addArticle(formData).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.editFormVisible = false
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getArticleList()
          } else {
            this.$message.error(res.msg);
          }
        });
      },

        
      // 删除
      deleteArticle(index, row) {
        this.$confirm("确定要删除吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            deleteArticle({ id: row.id })
              .then((res) => {
                if (res.code == 200) {
                  this.$message({
                    type: "success",
                    message: "已删除！",
                  });
                  this.getArticleList();
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("删除失败，请稍后再试！");
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
  
    
      //修改
      upArticle() {
        this.loading = true;
        var formData = this.formData;
        
        upArticle(formData).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.editFormVisible = false
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getArticleList()
          } else {
            this.$message.error(res.msg);
          }
        });
      },
  
        //修改
    addArticle() {
        this.loading = true;
        var formData = this.formData;
        
        addArticle(formData).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.editFormVisible = false
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getArticleList()
          } else {
            this.$message.error(res.msg);
          }
        });
      },
      getArticleList() {
        this.loading = true;
        getArticleList({type:0}).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.listData = res.data.list;
            return;
          }
          this.$message({
            type: "info",
            message: res.msg,
          });
        });
      },
  
  
  
      //显示编辑界面
      handleEdit: function (index, row) {
        this.editFormVisible = true;
        if (row != undefined && row != "undefined") {
          this.title = "修改";
          this.formData.id = row.id;
          this.formData.coverPlan = row.coverPlan;
          this.formData.address = row.address;
          this.formData.title = row.title;
          this.formData.richText = row.richText;

  
  
        } else {
          this.title = "添加";
          this.formData.id = "";
          this.formData.coverPlan = "";
          this.formData.address = "";
          this.formData.title = "";
          this.formData.richText = "";

  
        }
      },
  
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false;
      },
    },
  };
  </script>
  
  <style   scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  .upload-demo {
    display: flex;
    flex-direction: row;
  }
  
  .upload-demo img {
    width: 140px;
    height: 140px;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/activity/Activity.vue